import { useEffect } from "react";
import { useTheme } from "@mui/material";
import "quill/dist/quill.snow.css";
import "quill-table-ui/dist/index.css"; // Required for 3-dot table UI

import { useQuill } from "react-quilljs";
import Quill from "quill";

// Register Quill table modules
import Table from "quill/modules/table";
import TableUI from "quill-table-ui";

Quill.register(
  {
    "modules/table": Table,
    "modules/tableUI": TableUI,
  },
  true
);

const QuillEditor = ({
  value,
  onChange,
  placeholder = "Enter text here",
}: {
  value: string;
  onChange: (value: any) => void;
  placeholder?: string;
}) => {
  const theme = useTheme();

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      ["link", "image", "video", "formula"],
      [{ header: 1 }, { header: 2 }],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["table"], // Table button in toolbar
    ],
    table: true,
    tableUI: true,
  };

  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "code-block",
    "header",
    "list",
    "bullet",
    "check",
    "link",
    "image",
    "video",
    "formula",
    "script",
    "indent",
    "direction",
    "size",
    "color",
    "background",
    "font",
    "align",
    "table",
  ];

  const { quill, quillRef } = useQuill({
    theme: "snow",
    modules,
    formats,
    placeholder,
  });

  useEffect(() => {
    if (quill) {
      quill.clipboard.dangerouslyPasteHTML(value);
      quill.on("text-change", () => {
        const newValue = quill.root.innerHTML;
        onChange(newValue);
      });
    }
  }, [quill]);

  return (
    <div
      style={{
        width: "100%",
        border: "1px solid lightgray",
        // borderRadius: theme.shape.borderRadius,
      }}
    >
      <div ref={quillRef} />

      {/* Inline custom styles for Quill Table */}
      <style>
        {`
          /* Table styling */
          .ql-editor .ql-table {
            border: 1px solid red !important;
            border-collapse: collapse;
            width: 100%;
          }

          .ql-editor .ql-table td {
            background-color: #f0f8ff !important;
            padding: 8px !important;
            border: 1px solid #ccc !important;
          }

          /* 3-dot table UI button styling */
          .ql-toolbar .ql-formats .ql-table-ui,
          .ql-toolbar .ql-formats .ql-tableUI {
            background-color: yellow !important;
            border: 2px solid blue !important;
            border-radius: 4px;
            padding: 4px;
            margin-left: 4px;
          }

          .ql-toolbar .ql-formats .ql-table-ui:hover {
            background-color: #ffeeba !important;
          }
        `}
      </style>
    </div>
  );
};

export default QuillEditor;
